module.exports = __webpack_public_path__ + "src/assets/img/guest_header.23ad04d5.jpg";